/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createStagingPassengerDataFromDiscriminatorValue, type ProblemDetails, type StagingPassengerData } from '../models/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { CreateFromCsvRequestBuilderRequestsMetadata, type CreateFromCsvRequestBuilder } from './createFromCsv/index.js';
// @ts-ignore
import { InsertSelectedPassengerDataRequestBuilderRequestsMetadata, type InsertSelectedPassengerDataRequestBuilder } from './insertSelectedPassengerData/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /StagingPassengerData
 */
export interface StagingPassengerDataRequestBuilder extends BaseRequestBuilder<StagingPassengerDataRequestBuilder> {
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * The CreateFromCsv property
     */
    get createFromCsv(): CreateFromCsvRequestBuilder;
    /**
     * The InsertSelectedPassengerData property
     */
    get insertSelectedPassengerData(): InsertSelectedPassengerDataRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<StagingPassengerData[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<StagingPassengerData[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const StagingPassengerDataRequestBuilderUriTemplate = "{+baseurl}/StagingPassengerData";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const StagingPassengerDataRequestBuilderNavigationMetadata: Record<Exclude<keyof StagingPassengerDataRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
    createFromCsv: {
        requestsMetadata: CreateFromCsvRequestBuilderRequestsMetadata,
    },
    insertSelectedPassengerData: {
        requestsMetadata: InsertSelectedPassengerDataRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const StagingPassengerDataRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: StagingPassengerDataRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createStagingPassengerDataFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
